import { Button, Flex, Mask, toast } from '@solinkcorp/solink-components';
import * as LocationActions from 'actions/LocationActions';
import { type IEvent } from 'clients/PlatformApi';
import AnalyticsLogger from 'models/AnalyticsLogger';
import React, { useCallback, useState } from 'react';
import useLocale from 'src/hooks/useLocale';
import { type VideoDiscoverySite } from 'utils/types';
import { STATUS_FAILED, STATUS_SUCCEEDED } from 'vd-constants';
import './AlarmEventActions.sass';

export interface AlarmEventActionsProps {
  event: IEvent;
  location: VideoDiscoverySite;
  onClose: () => void;
}

const AlarmEventActions: React.FC<AlarmEventActionsProps> = ({ event, location, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const locale = useLocale();
  const eventId = event.id;

  const locationId = location?.id || '';
  const locationName = location?.name || '';

  const closeAlarm = useCallback(() => {
    setIsLoading(true);

    const successCallback = () => {
      setIsLoading(false);
      onClose();
      toast.success(locale.alarms.closeAlarmSuccess);
      AnalyticsLogger.alarmClose({
        eventId,
        locationId,
        locationName,
        status: STATUS_SUCCEEDED,
        siteId: locationId,
      });
    };
    const errorCallback = (err: Error) => {
      console.error(err);
      setIsLoading(false);
      toast.error(locale.alarms.closeAlarmError);
      AnalyticsLogger.alarmClose({
        eventId,
        locationId,
        locationName,
        status: STATUS_FAILED,
        siteId: locationId,
      });
    };

    if (locationId) {
      LocationActions.closeAlarm(locationId, eventId).then(successCallback, errorCallback);
    }
  }, [locationId, locationName, eventId, onClose, locale]);

  return (
    <>
      {isLoading && <Mask loading={isLoading} position="absolute" background="rgba(0,0,0,0.5)" />}
      <Flex
        className={`footer-actions-wrapper ${
          event.details?.isAccessRequestEvent ? 'access-control-actions' : 'alarm-actions'
        }`}
      >
        <Button
          className="clip-button"
          colorMode={'line-dark'}
          onClick={closeAlarm}
          size="full"
          text={locale.general.close}
        />
      </Flex>
    </>
  );
};

export default AlarmEventActions;
